    import React, { useState, useEffect } from 'react';

    function App() {
      const [users, setUsers] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);

      useEffect(() => {
        const fetchUsers = async () => {
          try {
            const response = await fetch('https://jsonplaceholder.typicode.com/users');
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setUsers(data);
          } catch (error) {
            setError(error);
          } finally {
            setLoading(false);
          }
        };

        fetchUsers();
      }, []);

      if (loading) return <div>Loading users...</div>;
      if (error) return <div>Error: {error.message}</div>;

      return (
        <div>
          <h1>User List Via Puplic Api</h1>
          <ul>
            {users.map(user => (
              <li key={user.id}>
                <div>
                  <strong>{user.name}</strong> ({user.email})
                  <br />
                    <span className="website">WEBSITE : </span><a href={user.website}>{user.website}</a>
                  <br />
                  <span className="number">PH.Number : </span><span>{user.phone}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    }

    export default App;